
const PREVIEW_PPI = 12; 

// --- State & DOM Elements ---
const elements = {
    form: document.getElementById('frame-form'),
    imageUpload: document.getElementById('image-upload'),
    selectorContainer: document.getElementById('frame-selector'),
    widthInput: document.getElementById('width'),
    heightInput: document.getElementById('height'),
    paddingInput: document.getElementById('padding'),
    zoomInput: document.getElementById('zoom'),
    widthVal: document.getElementById('width-val'),
    heightVal: document.getElementById('height-val'),
    paddingVal: document.getElementById('padding-val'),
    zoomVal: document.getElementById('zoom-val'),
    qtyVal: document.getElementById('qty-val'),
    areaVal: document.getElementById('area-val'),
    priceVal: document.getElementById('price-val'),
    frame: document.getElementById('frame'),
    image: document.getElementById('preview-image'),
    debugStatus: document.getElementById('debug-status'),
    debugLoads: document.getElementById('debug-loads'),
    debugUrl: document.getElementById('debug-url'),
    scrollLeft: document.getElementById('scroll-left'),
    scrollRight: document.getElementById('scroll-right'),
    cartQty: document.getElementById('cart-qty-hidden'),
    // Hidden Form Inputs
    hiddenId: document.getElementById('form-variant-id'),
    hiddenQty: document.getElementById('form-quantity'),
    hiddenDims: document.getElementById('form-dims'),
    hiddenStyle: document.getElementById('form-style'),
    hiddenPadding: document.getElementById('form-padding'),
    hiddenZoom: document.getElementById('form-zoom'),
    hiddenPreviewUrl: document.getElementById('form-preview-url')
};

let currentFrameStyle = FRAME_CONFIG[0].id; 
let renderTimeout = null;
let activeRequestId = 0;
let totalLoads = 0;
let panX = 50, panY = 50;
let isDragging = false, startMouseX = 0, startMouseY = 0;

// ==========================================
// 2. DYNAMIC UI GENERATION
// ==========================================
function initializeFrameSelector() {
    elements.selectorContainer.innerHTML = ''; 

    FRAME_CONFIG.forEach(frame => {
    const option = document.createElement('div');
    option.className = `frame-option ${frame.id === currentFrameStyle ? 'active' : ''}`;
    option.dataset.id = frame.id;

    let thumbStyle = frame.type === 'image' 
        ? `border: 6px solid transparent; border-image-source: url('${frame.source}'); border-image-slice: ${frame.slice};`
        : `border: 6px solid ${frame.value};`;
    if (frame.value === '#ffffff') thumbStyle += `box-shadow: 0 0 2px rgba(0,0,0,0.2) inset;`; 

    option.innerHTML = `
        <div class="frame-thumb-box">
        <div class="thumb-inner" style="${thumbStyle}"></div>
        </div>
        <div class="frame-meta">
        <span>${frame.name}</span>
        <span>$${frame.ratePerSqIn} per sq in</span>
        </div>
    `;

    option.addEventListener('click', () => {
        document.querySelectorAll('.frame-option').forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
        currentFrameStyle = frame.id;
        handleInteraction();
    });

    elements.selectorContainer.appendChild(option);
    });
}

elements.scrollLeft.addEventListener('click', () => elements.selectorContainer.scrollBy({ left: -100, behavior: 'smooth' }));
elements.scrollRight.addEventListener('click', () => elements.selectorContainer.scrollBy({ left: 100, behavior: 'smooth' }));

// ==========================================
// 3. INSTANT UI UPDATE LOGIC & PRICING
// ==========================================
function handleInteraction() {
    const wInches = parseFloat(elements.widthInput.value);
    const hInches = parseFloat(elements.heightInput.value);
    const pInches = parseFloat(elements.paddingInput.value);
    const zoomLevel = parseFloat(elements.zoomInput.value);
    const frameData = FRAME_CONFIG.find(f => f.id === currentFrameStyle);

    // --- CALCULATIONS ---
    // 1. Quantity of Frame Material (Perimeter)
    const linearInches = (wInches + hInches) * 2;
    
    // 2. Area
    const squareInches = wInches * hInches;
    
    // 3. Price (Area * Rate)
    const totalPrice = squareInches * frameData.ratePerSqIn;

    // Update text labels
    elements.widthVal.textContent = `${wInches}"`;
    elements.heightVal.textContent = `${hInches}"`;
    elements.paddingVal.textContent = `${pInches}"`;
    elements.zoomVal.textContent = `${zoomLevel.toFixed(1)}x`;
    
    // Update Summary UI
    elements.qtyVal.textContent = `${linearInches}" (Linear)`;
    elements.cartQty.value = squareInches;
    elements.areaVal.textContent = `${squareInches} sq in`;
    elements.priceVal.textContent = `$${totalPrice.toFixed(2)}`;

    // Update visual frame
    elements.frame.style.width = `${wInches * PREVIEW_PPI}px`;
    elements.frame.style.height = `${hInches * PREVIEW_PPI}px`;
    elements.frame.style.padding = `${pInches * PREVIEW_PPI}px`;

    if (frameData.type === 'image') {
    elements.frame.style.borderStyle = 'solid';
    elements.frame.style.borderWidth = `${frameData.thickness}px`;
    elements.frame.style.borderColor = 'transparent'; 
    elements.frame.style.borderImageSource = `url('${frameData.source}')`;
    elements.frame.style.borderImageSlice = frameData.slice;
    elements.frame.style.borderImageRepeat = 'stretch';
    } else {
    elements.frame.style.borderStyle = 'solid';
    elements.frame.style.borderWidth = `${frameData.thickness}px`;
    elements.frame.style.borderColor = frameData.value;
    elements.frame.style.borderImageSource = 'none'; 
    }

    elements.image.style.transform = `scale(${zoomLevel})`;
    elements.image.style.objectPosition = `${panX}% ${panY}%`;
    
    // Update Hidden Form Fields for submission
    elements.hiddenId.value = frameData.variantId;
    elements.hiddenQty.value = 1; // Crucial for price calculation
    elements.hiddenDims.value = `${wInches}" x ${hInches}"`;
    elements.hiddenStyle.value = frameData.name;
    elements.hiddenPadding.value = `${pInches}"`;
    elements.hiddenZoom.value = `${zoomLevel.toFixed(1)}x`;

    scheduleFinalImageRender(wInches, hInches, pInches, currentFrameStyle, zoomLevel);
}

// ==========================================
// 4. PAN, UPLOAD & ASYNC LOGIC
// ==========================================
elements.image.addEventListener('mousedown', (e) => { isDragging = true; startMouseX = e.clientX; startMouseY = e.clientY; });
window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    panX = Math.max(0, Math.min(100, panX - ((e.clientX - startMouseX) * 0.2))); 
    panY = Math.max(0, Math.min(100, panY - ((e.clientY - startMouseY) * 0.2)));
    startMouseX = e.clientX; startMouseY = e.clientY;
    handleInteraction();
});
window.addEventListener('mouseup', () => { isDragging = false; });
window.addEventListener('mouseleave', () => { isDragging = false; });

elements.imageUpload.addEventListener('change', (event) => {
    if (event.target.files[0]) {
    elements.image.src = URL.createObjectURL(event.target.files[0]);
    panX = 50; panY = 50; elements.zoomInput.value = 1;
    handleInteraction();
    }
});

function scheduleFinalImageRender(wInches, hInches, pInches, style, zoom) {
    if (renderTimeout) clearTimeout(renderTimeout);
    renderTimeout = setTimeout(() => executeMockRenderRequest(wInches, hInches, pInches, style, zoom), 400);
}

async function executeMockRenderRequest(wInches, hInches, pInches, style, zoom) {
    activeRequestId++; const currentRequestId = activeRequestId;
    elements.debugStatus.textContent = 'Loading...'; elements.debugStatus.className = 'status-badge status-loading';
    elements.image.classList.add('loading-img'); 

    await new Promise(resolve => setTimeout(resolve, 1500));
    if (currentRequestId !== activeRequestId) return; 

    totalLoads++;
    const mockImageId = elements.imageUpload.files.length > 0 ? elements.imageUpload.files[0].name : "default_art";
    elements.debugLoads.textContent = totalLoads;
    elements.debugUrl.textContent = `https://api.image.service/render?img=${encodeURIComponent(mockImageId)}&frame=${style}&w=${wInches}&h=${hInches}&pad=${pInches}&z=${zoom}&px=${Math.round(panX)}&py=${Math.round(panY)}`;
    elements.debugStatus.textContent = 'Idle'; elements.debugStatus.className = 'status-badge status-idle';
    elements.image.classList.remove('loading-img');
}

// Attach Input Listeners
['input'].forEach(evt => {
    elements.widthInput.addEventListener(evt, handleInteraction);
    elements.heightInput.addEventListener(evt, handleInteraction);
    elements.paddingInput.addEventListener(evt, handleInteraction);
    elements.zoomInput.addEventListener(evt, handleInteraction);
});

// Boot Up
initializeFrameSelector();
handleInteraction();

// Handle Form Submission - Generate Preview Image Here
elements.form.addEventListener('submit', async (e) => {
    // 1. Prevent default form submission
    e.preventDefault();

    // 2. CHECK: Ensure artwork is selected
    if (!elements.imageUpload.files.length) {
        alert("Please select an artwork file to frame.");
        return; // Stop execution if no file is selected
    }

    // 3. Generate Preview Blob
    const blob = await generatePreviewBlob();
    const file = new File([blob], "frame-preview.jpg", { type: "image/jpeg" });

    // 4. Attach generated preview to hidden input
    const dt = new DataTransfer();
    dt.items.add(file);
    // Assuming your hidden file input has ID "preview-upload"
    document.getElementById("preview-upload").files = dt.files;

    // 5. Submit the form
    elements.form.submit();
});
// Function to generate the canvas snapshot
function generatePreviewBlob() {
  return new Promise((resolve, reject) => {
    const wInches = parseFloat(elements.widthInput.value);
    const hInches = parseFloat(elements.heightInput.value);
    const pInches = parseFloat(elements.paddingInput.value);
    const zoomLevel = parseFloat(elements.zoomInput.value);

    const frameData = FRAME_CONFIG.find(f => f.id === currentFrameStyle);

    // Match preview aspect ratio to chosen dimensions
    const MAX_SIDE = 1200; // adjust if you want bigger previews
    const aspect = wInches / hInches;

    let canvasW, canvasH;
    if (aspect >= 1) {
      canvasW = MAX_SIDE;
      canvasH = Math.round(MAX_SIDE / aspect);
    } else {
      canvasH = MAX_SIDE;
      canvasW = Math.round(MAX_SIDE * aspect);
    }

    const canvas = document.createElement('canvas');
    canvas.width = canvasW;
    canvas.height = canvasH;

    const ctx = canvas.getContext('2d');
    if (!ctx) return reject(new Error("Canvas context not available"));

    // Background (matte color)
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvasW, canvasH);

    // --- Define areas in the snapshot ---
    // Frame border thickness (purely visual in snapshot)
    const frameBorder = Math.max(8, Math.round(Math.min(canvasW, canvasH) * 0.04)); // ~4% of short side
    // Matte padding area inside frame
    const mattePad = Math.round((pInches / Math.max(wInches, hInches)) * Math.min(canvasW, canvasH) * 0.7);

    // Outer frame rect
    const outerX = 0;
    const outerY = 0;
    const outerW = canvasW;
    const outerH = canvasH;

    // Inner opening where artwork should appear (inside matte + frame)
    const innerX = outerX + frameBorder + mattePad;
    const innerY = outerY + frameBorder + mattePad;
    const innerW = outerW - (frameBorder + mattePad) * 2;
    const innerH = outerH - (frameBorder + mattePad) * 2;

    // Draw matte area (between frame and opening)
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(outerX + frameBorder, outerY + frameBorder, outerW - frameBorder * 2, outerH - frameBorder * 2);

    // Load the visible preview image
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      // Clip to inner opening so artwork doesn't spill into matte/frame
      ctx.save();
      ctx.beginPath();
      ctx.rect(innerX, innerY, innerW, innerH);
      ctx.clip();

      // Draw artwork with "cover" behavior + zoom + pan (object-position)
      drawCover(ctx, img, innerX, innerY, innerW, innerH, zoomLevel, panX, panY);

      ctx.restore();

      // Draw frame (color/texture simplified)
      if (frameData.type === "color") {
        ctx.strokeStyle = frameData.value;
      } else {
        // Snapshot texture: you can improve later by pattern fill; this avoids complexity.
        ctx.strokeStyle = "#333";
      }
      ctx.lineWidth = frameBorder;
      ctx.strokeRect(frameBorder / 2, frameBorder / 2, canvasW - frameBorder, canvasH - frameBorder);

      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error("Failed to create blob"));
        resolve(blob);
      }, "image/jpeg", 0.9);
    };

    img.onerror = () => reject(new Error("Failed to load preview image for snapshot"));
    img.src = elements.image.src;
  });
}

/**
 * Draw image like CSS object-fit: cover + object-position (%), plus extra zoom multiplier
 */
function drawCover(ctx, img, x, y, w, h, zoom = 1, posXPercent = 50, posYPercent = 50) {
  const iw = img.naturalWidth || img.width;
  const ih = img.naturalHeight || img.height;

  // Base scale to cover the target rect
  const baseScale = Math.max(w / iw, h / ih);

  // Apply zoom (your slider)
  const scale = baseScale * zoom;

  const sw = iw * scale;
  const sh = ih * scale;

  // Max overflow beyond the target rect
  const overflowX = Math.max(0, sw - w);
  const overflowY = Math.max(0, sh - h);

  // Convert object-position % to offsets
  // 0% => align left/top, 50% => center, 100% => align right/bottom
  const ox = -overflowX * (posXPercent / 100);
  const oy = -overflowY * (posYPercent / 100);

  ctx.drawImage(img, x + ox, y + oy, sw, sh);
}
